module.exports = __webpack_public_path__ + "img/gjort-til-grin-1.ca477931.png";